'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Rules.StrategyRowDetails', []).controller('StrategyRowDetailsController', require('./controllers/StrategyRowDetailsController')).directive('rmStrategyRowDetails', require('./directives/StrategyRowDetailsDirective'));